import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type QuantityComponentProps = {
    quantity: number;
};

const QuantityComponent = ({ quantity }: QuantityComponentProps) => {
    const { t } = useGranite();

    return (
        <p className={"m-0"}>
            <span className={"mr-1"}>{t("general.cart.quantity.label")}</span>
            {quantity}
        </p>
    );
};

export { QuantityComponent };
